import { useMutation } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const useSearchVisitors = () => {
  return useMutation({
    mutationKey: ['search-visitors'],
    mutationFn: async (search: string) => {
      const { data, error } = await supabaseApi.rpc('search_visitors', { searchvalue: search })
      if (error) throw error

      return data
    },
  })
}
